export const HMPRepeatedValues = {
  treatment: '',
  exercises: [],
  status: '',
  recommendations: '',
};
